// src/index.js

// 1) Your normal app imports
import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// 2) EXTRA: import classic react-dom under a DIFFERENT name for the widget
//    (do NOT reuse the name used for createRoot)
import * as ReactGlobal from 'react';
import * as ReactDOMLegacy from 'react-dom';

// 3) Expose your app’s React to the UMD bundle
window.React = ReactGlobal;
window.ReactDOM = ReactDOMLegacy;

/* -------------------- DEV-ONLY TOKEN SEED (Option B) -------------------- */
/* Replace the strings below with real JWTs from your auth flow.
   This block only sets them if they're not already present. */
if (!localStorage.getItem('serviceToken')) {
  localStorage.setItem('serviceToken', 'PASTE_YOUR_SERVICE_JWT_HERE');
}
if (!localStorage.getItem('cdStaffToken')) {
  localStorage.setItem('cdStaffToken', 'PASTE_YOUR_CD_JWT_HERE');
}
/* ----------------------------------------------------------------------- */

// 4) Normal CRA render
const root = createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Optional CRA perf hook
reportWebVitals();
